import React, { useEffect, useState } from "react";
import { Card, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, Typography, TableContainer, CircularProgress, Grid } from "@mui/material";
import axios from "axios";

// ** Utils Import

interface OrderStatus {
    printing: number;
    dyeing: number;
    digital: number;
}

export default function StatusOrderTable() {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any>([]);

    useEffect(() => {
        const fetchData = () => {
            setLoading(true)
            // axios.get(apiUrl.apiUrl + "/api/produksi/dashboard-produksi/tabel-onhand").then((res) => {
            //     const datas = res.data.data
            //     setData(datas);
            //     setLoading(false)
            // });
            setLoading(false)
        };


        fetchData();
        const interval = setInterval(fetchData, 600000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Card sx={{ height: 250, overflow: "hidden" }}>
            {loading ? (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                    <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                </Grid>
            ) : (
                <TableContainer sx={{ maxHeight: 250 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Status Order</TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>XXXX</TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>XXXX</TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>XXXX</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row: any, idx: any) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.status_order}</TableCell>
                                    <TableCell align="right">{row.printing}</TableCell>
                                    <TableCell align="right">{row.dyeing}</TableCell>
                                    <TableCell align="right">{row.digital}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: 'yellow' }}>
                                <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                    {Number(
                                        data.reduce((sum: number, row: any) => {
                                            // Remove separator (assume '.' or ',' for thousands)
                                            const value = typeof row.printing === 'string'
                                                ? row.printing.replace(/[.,]/g, '')
                                                : row.printing || 0;
                                            return sum + Number(value);
                                        }, 0)
                                    ).toLocaleString()}
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                    {Number(
                                        data.reduce((sum: number, row: any) => {
                                            // Remove separator (assume '.' or ',' for thousands)
                                            const value = typeof row.dyeing === 'string'
                                                ? row.dyeing.replace(/[.,]/g, '')
                                                : row.dyeing || 0;
                                            return sum + Number(value);
                                        }, 0)
                                    ).toLocaleString()}
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                    {Number(
                                        data.reduce((sum: number, row: any) => {
                                            // Remove separator (assume '.' or ',' for thousands)
                                            const value = typeof row.digital === 'string'
                                                ? row.digital.replace(/[.,]/g, '')
                                                : row.digital || 0;
                                            return sum + Number(value);
                                        }, 0)
                                    ).toLocaleString()}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Card>
    );
}
